


export const testObject=(token)=>Number.isInteger(token);


const serialize=(token)=>Object.is(token,-0)?"-0":String(token);


const testString=(chars)=>INTEGER_REGEXP.test(chars);

const INTEGER_REGEXP=/^-?\d+$/u;


const parse=Number;


const normalize=(token)=>token;


const equals=(tokenA,tokenB)=>Object.is(tokenA,tokenB);

export const INDEX_TOKEN={
name:"index",
testObject,
serialize,
testString,
parse,
normalize,
equals
};